// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cTpz","colMin":"styles_colMin__UB8rL"};